// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Menu: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="10.001" height="10.001" viewBox="0 0 10.001 10.001">
            <path d="M9.70625067,8.29453087 C10.0968757,8.68515587 10.0968757,9.31796837 9.70625067,9.70859337 C9.51250029,9.90390587 9.25625086,10.0007811 9,10.0007811 C8.7437501,10.0007811 8.48812532,9.90312481 8.29312563,9.70781231 L5,6.41640568 L1.70718813,9.70703125 C1.51187563,9.90390587 1.25593805,10.0007811 1,10.0007811 C0.744062901,10.0007811 0.488437653,9.90390587 0.29296875,9.70703125 C-0.09765625,9.31640625 -0.09765625,8.68359375 0.29296875,8.29296875 L3.58671904,4.99921894 L0.29296875,1.70703125 C-0.09765625,1.31640625 -0.09765625,0.68359375 0.29296875,0.29296875 C0.68359375,-0.09765625 1.31640625,-0.09765625 1.70703125,0.29296875 L5,3.58828115 L8.29374981,0.294530869 C8.68437481,-0.0960941315 9.31718731,-0.0960941315 9.70781231,0.294530869 C10.0984373,0.685155869 10.0984373,1.31796837 9.70781231,1.70859337 L6.4140625,5.00234318 L9.70625019,8.29453087 L9.70625067,8.29453087 Z" />
        </svg>
    );
};

export default React.memo(Menu);
